import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  PREVIOUS_BUTTON: `${cleanedFilename(__filename)}-previous-button`,
  NEXT_BUTTON: `${cleanedFilename(__filename)}-next-button`,
  CLOSE_BUTTON: `${cleanedFilename(__filename)}-close-button`,
};
